import React from 'react';
import clsx from 'clsx';
import { CircularProgress, styled } from '@nextiva/next-ui-components';
import styles from './NextivaAppBlock.scss';

const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;

const NextivaAppBlock = ({
  title,
  subtitle,
  accessible,
  iconName,
  children,
  loading,
}) => {
  const accessibleIconClass = `icon-custom-${
    accessible ? 'check' : 'key-fill'
  }`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.iconSection}>
        <i className={clsx(`icon-custom-${iconName}`, styles.icon)} />
        <div className={styles.actionsContainer}>{children}</div>
      </div>

      <div className={styles.titleSection}>
        <div
          className={clsx(
            styles.accessibleIcon,
            accessible ? styles.allowed : styles.locked,
          )}
        >
          {loading ? (
            <StyledCircularProgress size={16} />
          ) : (
            <i className={accessibleIconClass} />
          )}
        </div>
        <div>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
    </div>
  );
};

export default NextivaAppBlock;
